/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

// TODO: refine properties (especially valid & visible & name)
export const SubmissionStatus = {
  DRAFT: {
    id: 'DRAFT',
    name: 'Draft',
    i18nKey: 'submission.status.draft',
    visible: true,
    valid: false,
    statusOrder: 1,
    dashboard: true,
  },
  // front-end only status, built on top of DRAFT
  VALID_DRAFT: {
    id: 'VALID_DRAFT',
    name: 'Valid draft',
    i18nKey: 'submission.status.draft',
    visible: true,
    valid: true,
    statusOrder: 2,
  },
  READY_TO_SIGN: {
    id: 'READY_TO_SIGN',
    name: 'Ready to sign',
    i18nKey: 'submission.status.ready.to.sign',
    visible: true,
    valid: false,
    statusOrder: 3,
    dashboard: true,
  },
  VALID_READY_TO_SIGN: {
    id: 'VALID_READY_TO_SIGN',
    name: 'Valid ready to sign',
    i18nKey: 'submission.status.ready.to.sign',
    visible: true,
    valid: true,
    statusOrder: 15,
  },
  SENT_TO_SIGN: {
    id: 'SENT_TO_SIGN',
    name: 'Sent to sign',
    i18nKey: 'submission.status.sent.to.filing',
    visible: false,
    valid: false,
    statusOrder: 5,
  },
  SIGNING_FAILED: {
    id: 'SIGNING_FAILED',
    name: 'Signing Failed',
    i18nKey: 'submission.status.signing.failed',
    visible: true,
    valid: false,
    statusOrder: 11,
    type: 'error',
  },
  READY_TO_PAY: {
    id: 'READY_TO_PAY',
    name: 'Ready to pay',
    i18nKey: 'submission.status.ready.to.pay',
    visible: false,
    valid: false,
    dashboard: true,
    statusOrder: 12,
  },
  PAID: {
    id: 'PAID',
    name: 'Paid',
    i18nKey: 'submission.status.paid',
    visible: false,
    valid: false,
    statusOrder: 13,
    dashboard: false,
  },
  RESIGNING_FAILED: {
    id: 'RESIGNING_FAILED',
    name: 'Re-signing Failed',
    i18nKey: 'submission.status.resigning.failed',
    visible: true,
    valid: false,
    statusOrder: 14,
    type: 'error',
  },
  READY_TO_SEND: {
    id: 'SIGNED',
    name: 'Ready to send',
    i18nKey: 'submission.status.ready.to.send',
    visible: true,
    valid: false,
    statusOrder: 6,
    dashboard: true,
  },
  SENT_TO_FILING: {
    id: 'SENT_TO_FILING',
    name: 'Sent to filing',
    i18nKey: 'submission.status.sent.to.filing',
    visible: false,
    valid: false,
    statusOrder: 7,
  },
  SENDING_FAILED: {
    id: 'SENDING_FAILED',
    name: 'Sending Failed',
    i18nKey: 'submission.status.sending.failed',
    visible: true,
    valid: false,
    statusOrder: 10,
    type: 'error',
  },
  SENT: {
    id: 'SENT',
    name: 'Sent',
    i18nKey: 'submission.status.sent',
    visible: true,
    valid: false,
    statusOrder: 9,
  },
};

export const getSubmissionStatusById = id => Object.values(SubmissionStatus).find(item => item.id === id);

export const getSubmissionStatusId = statusOrder =>
  Object.values(SubmissionStatus).find(item => item?.statusOrder === statusOrder)?.id;
export const isStatusReadOnly = id => id && ![SubmissionStatus.DRAFT.id].includes(id);

export const selectFailedStatuses = value => value.includes('FAILED');

export const getDashboardStatuses = () =>
  Object.values(SubmissionStatus)
    .filter(item => !!item.dashboard)
    .map(item => item.id);
